import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';


const VideoInterface = ({ 
  localStream, 
  remoteStream, 
  isVideoEnabled, 
  isAudioEnabled,
  onToggleVideo,
  onToggleAudio,
  connectionQuality 
}) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const getQualityColor = () => {
    switch (connectionQuality) {
      case 'excellent': return 'text-success';
      case 'good': return 'text-success';
      case 'fair': return 'text-warning';
      case 'poor': return 'text-error';
      default: return 'text-muted-foreground';
    }
  };

  const getQualityIcon = () => {
    switch (connectionQuality) {
      case 'excellent': return 'Wifi';
      case 'good': return 'Wifi';
      case 'fair': return 'WifiOff';
      case 'poor': return 'WifiOff';
      default: return 'Wifi';
    }
  };

  return (
    <div className="relative w-full h-full bg-gray-900 rounded-lg overflow-hidden">
      {/* Remote Video (Helper/Seeker) */}
      <div className="absolute inset-0 flex items-center justify-center">
        {remoteStream ? (
          <video
            autoPlay
            playsInline
            className="w-full h-full object-cover"
            ref={(video) => {
              if (video && remoteStream) {
                video.srcObject = remoteStream;
              }
            }}
          />
        ) : (
          <div className="flex flex-col items-center gap-4 text-white">
            <div className="w-24 h-24 rounded-full bg-primary/20 flex items-center justify-center">
              <Icon name="User" size={48} className="text-primary" />
            </div>
            <p className="text-lg font-medium">Waiting for participant...</p>
          </div>
        )}
      </div>

      {/* Local Video (Self View) */}
      <div className="absolute bottom-4 right-4 w-48 h-36 bg-gray-800 rounded-lg overflow-hidden border-2 border-white/20 shadow-lg">
        {localStream && isVideoEnabled ? (
          <video
            autoPlay
            playsInline
            muted
            className="w-full h-full object-cover mirror"
            ref={(video) => {
              if (video && localStream) {
                video.srcObject = localStream;
              }
            }}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <div className="w-16 h-16 rounded-full bg-primary/20 flex items-center justify-center">
              <Icon name="VideoOff" size={24} className="text-white" />
            </div>
          </div>
        )}
      </div>

      {/* Connection Quality Indicator */}
      <div className="absolute top-4 left-4 flex items-center gap-2 bg-black/50 backdrop-blur-sm px-3 py-2 rounded-lg">
        <Icon name={getQualityIcon()} size={16} className={getQualityColor()} />
        <span className="text-sm text-white font-medium capitalize">{connectionQuality}</span>
      </div>

      {/* Audio Muted Indicator */}
      {!isAudioEnabled && (
        <div className="absolute top-4 right-4 bg-error/90 backdrop-blur-sm px-3 py-2 rounded-lg flex items-center gap-2">
          <Icon name="MicOff" size={16} className="text-white" />
          <span className="text-sm text-white font-medium">Muted</span>
        </div>
      )}
    </div>
  );
};

export default VideoInterface;